import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage: React.FC = () => {
  return (
    <div className="text-center">
      <h1>404 - העמוד לא נמצא</h1>
      <Link to="/" className="text-blue-500 hover:underline">
        חזרה לדף הבית
      </Link>
    </div>
  );
};

export default NotFoundPage;
